import { ScrollingModule } from '@angular/cdk/scrolling';

import { Component, Input, OnInit } from '@angular/core';
import { IClient } from '@techspert-io/clients';
import { MaterialModule } from '../../../../shared/patterns/material-module';
import { EnrichedUser } from '../../models/user.models';
import { UserListItemComponent } from '../user-list-item/user-list-item.component';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['users-list.component.scss'],
  imports: [MaterialModule, ScrollingModule, UserListItemComponent],
})
export class UsersListComponent implements OnInit {
  itemSizePx = 89;
  minBufferPx = this.itemSizePx * 5;
  maxBufferPx = this.itemSizePx * 10;

  @Input() users: EnrichedUser[] = [];
  @Input() selectedUserId: string;
  @Input() clients: IClient[];

  private clientsDictionary: Record<string, IClient>;

  ngOnInit() {
    this.clientsDictionary = this.clients.reduce(
      (clients, client) => ({
        ...clients,
        [client.clientId]: client,
      }),
      {}
    );
  }

  getClientNames(user: EnrichedUser) {
    return [
      ...new Set(
        user.client_ids
          .map((clientId) => this.clientsDictionary[clientId]?.clientName)
          .filter(Boolean)
      ),
    ];
  }

  trackByUserId(_index: number, user: EnrichedUser) {
    return user.user_id;
  }
}
